<template>
    <div class="impressum">
      <img class="close-impressum" src="../assets/tipp/tipp-cross.svg" @click="$router.go(-1)">
      <LanguageSwitch class="lang-switch"></LanguageSwitch>
      <div class="textsheet regularlink">
        <h3>{{$t('impressum.titel')}}</h3>
        <p>
          <span v-html="$t('impressum.para1')"></span>
        </p>
      </div>

      <div class="multi-line">
        <div class="textsheet regularlink">
          <p>
            <span v-html="$t('impressum.herausgeber')"></span>
          </p>
          <p>
            <span v-html="$t('impressum.kontakt')"></span>
          </p>
        </div>
        <div class="textsheet regularlink">
          <p>
            <span v-html="$t('impressum.concept')"></span>
          </p>
          <p>
            <span v-html="$t('impressum.design')"></span>
          </p>
          <p>
            <span v-html="$t('impressum.development')"></span>
          </p>
        </div>

      </div>
    </div>
</template>

<script>
import LanguageSwitch from "@/components/LanguageSwitch";
    export default {
        name: "impressum",
      components: {
          LanguageSwitch
      }
    }
</script>

<style lang="scss" scoped>
.impressum {
  width: 100vw;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  padding: 70px;
}

.lang-switch {
  position: absolute;
  top: 0;
  right: 10%;

  @include tablet-down {
    right: 20%;
  }
}

.close-impressum {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 45px;
  cursor: pointer;

  @include mobile-down {
    width: 35px;
  }
}

.multi-line {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 80%;

  @include tablet-down {
    width: 100%;
  }
}

</style>